import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/pages/Home";
import About from "./components/pages/About";
import Services from "./components/pages/Services";
import Contact from "./components/pages/Contact";
import Industries from "./components/pages/Industries";
import Footer from "./components/Footer";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

const App = () => {
  // Custom component to conditionally render the Contact component
  const RenderContactForm = () => {
    const location = useLocation(); // Get the current route
    return location.pathname !== "/contact" ? <Contact /> : null; // Render Contact only if not on /contact
  };

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/industries" element={<Industries />} />
      </Routes>
      <RenderContactForm /> {/* Conditionally render the contact form */}
      <Footer />
    </Router>
  );
};

export default App;